import { useStore } from 'effector-react'

import {
  $giftOrders,
  $totalCountOfGiftOrders,
  getGiftOrders,
  giftOrdersListMounted,
} from './model'
import { GiftOrdersRequest } from './types'

export const useGiftOrdersList = () => {
  const onChangeGiftOrdersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: GiftOrdersRequest) => {
    giftOrdersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }
  const loading = useStore(getGiftOrders.pending)

  const giftOrders = useStore($giftOrders)
  const totalCountOfGiftOrders = useStore($totalCountOfGiftOrders)

  return {
    giftOrders,
    totalCountOfGiftOrders,
    loading,
    onChangeGiftOrdersList,
  }
}
